(function ($) {
  var industryArr = [];

  $('body .resource-grid .nav-wrapper .filter-wrap .tab-content .clear-filter').css('display','none');
  
  jQuery(document).on('click', '.resource-grid #resources-type li input', function (e) {
    // e.preventDefault();
    var str = jQuery(this).val();
    if (jQuery.inArray(str, industryArr) != '-1') {
      jQuery(".js-form-item-field-type-target-id").val(str)
        .find("option[value=" + str + "]").attr('selected', false);
      var index = industryArr.indexOf(str);
      if (index !== -1)
        industryArr.splice(index, 1);
    } else{
      industryArr.push(jQuery(this).val());
      jQuery(".js-form-item-field-type-target-id").val(str)
        .find("option[value=" + str + "]").attr('selected', true);
    }
    var text = $(this).next().text();
    if($(this).is(":checked"))
      $('body .resource-grid .nav-wrapper .filter-wrap #clear-filter>.clear-element').append('<span>'+text+'</span>')
    else{
      $('body .resource-grid .nav-wrapper .filter-wrap #clear-filter>.clear-element span').each(function () {
        if($(this).text() === text){
          $(this).remove();
        }
      });
    }
    if($('body .resource-grid .nav-wrapper .filter-wrap #clear-filter>.clear-element span').length > 0){
      $('body .resource-grid .nav-wrapper .filter-wrap .tab-content .clear-filter').css('display','inline-block');
    }else{
      $('body .resource-grid .nav-wrapper .filter-wrap .tab-content .clear-filter').css('display','none');
    }
    $("input[value='Apply']").trigger('click');
  });


   $('body .resource-grid .nav-wrapper .col-right .select-wrap select').on('change',function () {
      var item = $(this).val();
      $('.form-item-sort-order select option').each(function () {
          if($(this).val() === item){
            $(this).prop('selected', true);
          }
      });

     $("input[value='Apply']").trigger('click');
   });

  $(document).on('click','body .resource-grid .nav-wrapper .filter-wrap #clear-filter>.clear-element span',function () {
        var text = $(this).text();
        var th = $(this);
    $('.resource-grid #resources-type li').each(function () {
      if($(this).find('label').text() === text){
        $(this).find('input').trigger('click')
      }
    })
    $('.resource-grid #products li').each(function () {
      if($(this).find('label').text() === text){
        $(this).find('input').trigger('click');
      }
    });

    // Clear Language filter
    $('.resource-grid #language li').each(function () {
      if($(this).find('label').text() === text){
        $(this).find('input').trigger('click');
      }
    });
    if($('body .resource-grid .nav-wrapper .filter-wrap #clear-filter>.clear-element span').length > 0){
      $('body .resource-grid .nav-wrapper .filter-wrap .tab-content .clear-filter').css('display','inline-block');
    }else{
      $('body .resource-grid .nav-wrapper .filter-wrap .tab-content .clear-filter').css('display','none');
    }
  });

  $(document).on('click','body .resource-grid .nav-wrapper .filter-wrap .tab-content .clear-filter',function () {
    industryArr = [];
    products = [];
    language = [];
    $(this).css('display','none');
    $(this).parent().find('.clear-element').empty();
    $('.resource-grid .tab-content li').each(function () {
      $(this).find('input').prop("checked", false);
    });
    jQuery(".form-item-field-product-type-target-id").val('all')
      .find("option").attr('selected', false);
    jQuery(".js-form-item-field-type-target-id").val('all')
      .find("option").attr('selected', false);

    // Clear language filter
    jQuery(".form-item-field-language-target-id").val('all').find("option").attr('selected', false);

    $("input[value='Apply']").trigger('click');
  });

  var products = [];
  jQuery(document).on('click', '.resource-grid #products li input', function (e) {
    // e.preventDefault();
    var str = jQuery(this).val();
    if (jQuery.inArray(str, products) != '-1') {
      jQuery(".form-item-field-product-type-target-id").val(str)
        .find("option[value=" + str + "]").attr('selected', false);
      var index = products.indexOf(str);
      if (index !== -1)
        products.splice(index, 1);
    } else{
      products.push(jQuery(this).val());
      jQuery(".form-item-field-product-type-target-id").val(str)
        .find("option[value=" + str + "]").attr('selected', true);
    }

    var text = $(this).next().text();
    if($(this).is(":checked"))
      $('body .resource-grid .nav-wrapper .filter-wrap #clear-filter>.clear-element').append('<span>'+text+'</span>')
    else{
      $('body .resource-grid .nav-wrapper .filter-wrap #clear-filter>.clear-element span').each(function () {
        if($(this).text() === text){
          $(this).remove();
        }
      });
    }
    if($('body .resource-grid .nav-wrapper .filter-wrap #clear-filter>.clear-element span').length > 0){
      $('body .resource-grid .nav-wrapper .filter-wrap .tab-content .clear-filter').css('display','inline-block');
    }else{
      $('body .resource-grid .nav-wrapper .filter-wrap .tab-content .clear-filter').css('display','none');
    }
    $("input[value='Apply']").trigger('click');
  });


  // language filter
  var language = [];
  jQuery(document).on('click', '.resource-grid #language li input', function (e) {
    // e.preventDefault();
    var str = jQuery(this).val();
    if (jQuery.inArray(str, language) != '-1') {
      jQuery(".form-item-field-language-target-id").val(str)
          .find("option[value=" + str + "]").attr('selected', false);
      var index = language.indexOf(str);
      if (index !== -1)
        language.splice(index, 1);
    } else{
      language.push(jQuery(this).val());
      jQuery(".form-item-field-language-target-id").val(str)
          .find("option[value=" + str + "]").attr('selected', true);
    }

    var text = $(this).next().text();
    if($(this).is(":checked"))
      $('body .resource-grid .nav-wrapper .filter-wrap #clear-filter>.clear-element').append('<span>'+text+'</span>')
    else{
      $('body .resource-grid .nav-wrapper .filter-wrap #clear-filter>.clear-element span').each(function () {
        if($(this).text() === text){
          $(this).remove();
        }
      });
    }
    if($('body .resource-grid .nav-wrapper .filter-wrap #clear-filter>.clear-element span').length > 0){
      $('body .resource-grid .nav-wrapper .filter-wrap .tab-content .clear-filter').css('display','inline-block');
    }else{
      $('body .resource-grid .nav-wrapper .filter-wrap .tab-content .clear-filter').css('display','none');
    }
    $("input[value='Apply']").trigger('click');
  });

})(jQuery);
